module.exports = __webpack_public_path__ + "static/media/img_feature_photo1@2x.f8d9fa62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_feature_photo1@2x.jpg
// module id = 789
// module chunks = 0